import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DiagnosticListFieldsFragment = { __typename?: 'Diagnostic', id: string, name: string, diagnosticTemplateId?: string | null, status?: Types.DiagnosticStatus | null, minDueDate?: any | null, maxDueDate?: any | null, minStartDate?: any | null, maxStartDate?: any | null, countOfCompletedStudents: number, countOfIncompleteStudents: number, openMinDueDate?: any | null, openMaxDueDate?: any | null, scheduledMinStartDate?: any | null, scheduledMaxStartDate?: any | null };

export type DiagnosticsListQueryVariables = Types.Exact<{
  classroomIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  status?: Types.InputMaybe<Types.DiagnosticStatus>;
  isAllStatuses: Types.Scalars['Boolean']['input'];
  includeDueDates: Types.Scalars['Boolean']['input'];
  includeStartDates: Types.Scalars['Boolean']['input'];
  filter?: Types.InputMaybe<Types.DiagnosticFilterInput>;
  sort?: Types.InputMaybe<Array<Types.InputMaybe<Types.DiagnosticSortInput>> | Types.InputMaybe<Types.DiagnosticSortInput>>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  asEducatorId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type DiagnosticsListQuery = { __typename?: 'RootQueryType', diagnostics?: { __typename?: 'KeysetPageOfDiagnostic', endKeyset?: string | null, results?: Array<{ __typename?: 'Diagnostic', id: string, name: string, diagnosticTemplateId?: string | null, status?: Types.DiagnosticStatus | null, minDueDate?: any | null, maxDueDate?: any | null, minStartDate?: any | null, maxStartDate?: any | null, countOfCompletedStudents: number, countOfIncompleteStudents: number, openMinDueDate?: any | null, openMaxDueDate?: any | null, scheduledMinStartDate?: any | null, scheduledMaxStartDate?: any | null }> | null } | null };

export type DiagnosticStatusCountsQueryVariables = Types.Exact<{
  allFilter?: Types.InputMaybe<Types.DiagnosticFilterInput>;
  openFilter?: Types.InputMaybe<Types.DiagnosticFilterInput>;
  closedFilter?: Types.InputMaybe<Types.DiagnosticFilterInput>;
  scheduledFilter?: Types.InputMaybe<Types.DiagnosticFilterInput>;
  asEducatorId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type DiagnosticStatusCountsQuery = { __typename?: 'RootQueryType', all?: { __typename?: 'KeysetPageOfDiagnostic', count?: number | null } | null, open?: { __typename?: 'KeysetPageOfDiagnostic', count?: number | null } | null, closed?: { __typename?: 'KeysetPageOfDiagnostic', count?: number | null } | null, scheduled?: { __typename?: 'KeysetPageOfDiagnostic', count?: number | null } | null };

export const DiagnosticListFieldsFragmentDoc = gql`
    fragment DiagnosticListFields on Diagnostic {
  id
  name
  diagnosticTemplateId
  status(classroomIds: $classroomIds)
  minDueDate(classroomIds: $classroomIds, status: $status) @include(if: $includeDueDates)
  maxDueDate(classroomIds: $classroomIds, status: $status) @include(if: $includeDueDates)
  minStartDate(classroomIds: $classroomIds, status: $status) @include(if: $includeStartDates)
  maxStartDate(classroomIds: $classroomIds, status: $status) @include(if: $includeStartDates)
  openMinDueDate: minDueDate(classroomIds: $classroomIds, status: OPEN) @include(if: $isAllStatuses)
  openMaxDueDate: maxDueDate(classroomIds: $classroomIds, status: OPEN) @include(if: $isAllStatuses)
  scheduledMinStartDate: minStartDate(
    classroomIds: $classroomIds
    status: SCHEDULED
  ) @include(if: $isAllStatuses)
  scheduledMaxStartDate: maxStartDate(
    classroomIds: $classroomIds
    status: SCHEDULED
  ) @include(if: $isAllStatuses)
  countOfCompletedStudents(classroomIds: $classroomIds)
  countOfIncompleteStudents(classroomIds: $classroomIds)
}
    `;
export const DiagnosticsListDocument = gql`
    query DiagnosticsList($classroomIds: [ID!], $status: DiagnosticStatus, $isAllStatuses: Boolean!, $includeDueDates: Boolean!, $includeStartDates: Boolean!, $filter: DiagnosticFilterInput, $sort: [DiagnosticSortInput], $first: Int, $after: String, $asEducatorId: ID) {
  diagnostics(
    filter: $filter
    sort: $sort
    first: $first
    after: $after
    asEducatorId: $asEducatorId
  ) {
    endKeyset
    results {
      ...DiagnosticListFields
    }
  }
}
    ${DiagnosticListFieldsFragmentDoc}`;

/**
 * __useDiagnosticsListQuery__
 *
 * To run a query within a React component, call `useDiagnosticsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiagnosticsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiagnosticsListQuery({
 *   variables: {
 *      classroomIds: // value for 'classroomIds'
 *      status: // value for 'status'
 *      isAllStatuses: // value for 'isAllStatuses'
 *      includeDueDates: // value for 'includeDueDates'
 *      includeStartDates: // value for 'includeStartDates'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      asEducatorId: // value for 'asEducatorId'
 *   },
 * });
 */
export function useDiagnosticsListQuery(baseOptions: Apollo.QueryHookOptions<DiagnosticsListQuery, DiagnosticsListQueryVariables> & ({ variables: DiagnosticsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiagnosticsListQuery, DiagnosticsListQueryVariables>(DiagnosticsListDocument, options);
      }
export function useDiagnosticsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiagnosticsListQuery, DiagnosticsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiagnosticsListQuery, DiagnosticsListQueryVariables>(DiagnosticsListDocument, options);
        }
// @ts-ignore
export function useDiagnosticsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiagnosticsListQuery, DiagnosticsListQueryVariables>): Apollo.UseSuspenseQueryResult<DiagnosticsListQuery, DiagnosticsListQueryVariables>;
export function useDiagnosticsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiagnosticsListQuery, DiagnosticsListQueryVariables>): Apollo.UseSuspenseQueryResult<DiagnosticsListQuery | undefined, DiagnosticsListQueryVariables>;
export function useDiagnosticsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiagnosticsListQuery, DiagnosticsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiagnosticsListQuery, DiagnosticsListQueryVariables>(DiagnosticsListDocument, options);
        }
export type DiagnosticsListQueryHookResult = ReturnType<typeof useDiagnosticsListQuery>;
export type DiagnosticsListLazyQueryHookResult = ReturnType<typeof useDiagnosticsListLazyQuery>;
export type DiagnosticsListSuspenseQueryHookResult = ReturnType<typeof useDiagnosticsListSuspenseQuery>;
export type DiagnosticsListQueryResult = Apollo.QueryResult<DiagnosticsListQuery, DiagnosticsListQueryVariables>;
export const DiagnosticStatusCountsDocument = gql`
    query DiagnosticStatusCounts($allFilter: DiagnosticFilterInput, $openFilter: DiagnosticFilterInput, $closedFilter: DiagnosticFilterInput, $scheduledFilter: DiagnosticFilterInput, $asEducatorId: ID) {
  all: diagnostics(filter: $allFilter, first: 1, asEducatorId: $asEducatorId) {
    count
  }
  open: diagnostics(filter: $openFilter, first: 1, asEducatorId: $asEducatorId) {
    count
  }
  closed: diagnostics(
    filter: $closedFilter
    first: 1
    asEducatorId: $asEducatorId
  ) {
    count
  }
  scheduled: diagnostics(
    filter: $scheduledFilter
    first: 1
    asEducatorId: $asEducatorId
  ) {
    count
  }
}
    `;

/**
 * __useDiagnosticStatusCountsQuery__
 *
 * To run a query within a React component, call `useDiagnosticStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiagnosticStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiagnosticStatusCountsQuery({
 *   variables: {
 *      allFilter: // value for 'allFilter'
 *      openFilter: // value for 'openFilter'
 *      closedFilter: // value for 'closedFilter'
 *      scheduledFilter: // value for 'scheduledFilter'
 *      asEducatorId: // value for 'asEducatorId'
 *   },
 * });
 */
export function useDiagnosticStatusCountsQuery(baseOptions?: Apollo.QueryHookOptions<DiagnosticStatusCountsQuery, DiagnosticStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiagnosticStatusCountsQuery, DiagnosticStatusCountsQueryVariables>(DiagnosticStatusCountsDocument, options);
      }
export function useDiagnosticStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiagnosticStatusCountsQuery, DiagnosticStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiagnosticStatusCountsQuery, DiagnosticStatusCountsQueryVariables>(DiagnosticStatusCountsDocument, options);
        }
// @ts-ignore
export function useDiagnosticStatusCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiagnosticStatusCountsQuery, DiagnosticStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<DiagnosticStatusCountsQuery, DiagnosticStatusCountsQueryVariables>;
export function useDiagnosticStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiagnosticStatusCountsQuery, DiagnosticStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<DiagnosticStatusCountsQuery | undefined, DiagnosticStatusCountsQueryVariables>;
export function useDiagnosticStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiagnosticStatusCountsQuery, DiagnosticStatusCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiagnosticStatusCountsQuery, DiagnosticStatusCountsQueryVariables>(DiagnosticStatusCountsDocument, options);
        }
export type DiagnosticStatusCountsQueryHookResult = ReturnType<typeof useDiagnosticStatusCountsQuery>;
export type DiagnosticStatusCountsLazyQueryHookResult = ReturnType<typeof useDiagnosticStatusCountsLazyQuery>;
export type DiagnosticStatusCountsSuspenseQueryHookResult = ReturnType<typeof useDiagnosticStatusCountsSuspenseQuery>;
export type DiagnosticStatusCountsQueryResult = Apollo.QueryResult<DiagnosticStatusCountsQuery, DiagnosticStatusCountsQueryVariables>;